import _ from 'lodash'

export const listOfThings = (items: Array<string | number>, ending = 'and') => {
  if (items.length === 1) {
    return items[0]
  }
  if (items.length === 2) {
    return `${items[0]} ${ending} ${items[1]}`
  }
  const itemsWithoutLast = [...items]
  const lastItem = itemsWithoutLast.pop()
  return `${itemsWithoutLast.join(', ')}, ${ending} ${lastItem}`
}

const yWordBlacklist = ['day']

export const pluralize = (str: string) => {
  if (_.endsWith(str, 's')) {
    return `${str}es`
  }
  if (_.endsWith(str, 'y') && yWordBlacklist.indexOf(str.toLowerCase()) === -1) {
    return `${str.slice(0, -1)}ies`
  }
  return `${str}s`
}
export const maybePlural = (str: string, list: any[] | number) =>
  (_.isArray(list) ? list.length : list) > 1 ? pluralize(str) : str
